/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Seniority_ExecutiveInputs */

const en_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const de_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Führungskraft`)
};

const fr_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirigeant`)
};

const es_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutivo`)
};

const it_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const nl_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const pl_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Executive`)
};

const fi_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johtaja`)
};

const da_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktør`)
};

const sv_salary_seniority_executive = /** @type {(inputs: Salary_Seniority_ExecutiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direktör`)
};

/**
* | output |
* | --- |
* | "Executive" |
*
* @param {Salary_Seniority_ExecutiveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_seniority_executive = /** @type {((inputs?: Salary_Seniority_ExecutiveInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Seniority_ExecutiveInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_seniority_executive(inputs)
	if (locale === "fr") return fr_salary_seniority_executive(inputs)
	if (locale === "es") return es_salary_seniority_executive(inputs)
	if (locale === "it") return it_salary_seniority_executive(inputs)
	if (locale === "nl") return nl_salary_seniority_executive(inputs)
	if (locale === "pl") return pl_salary_seniority_executive(inputs)
	if (locale === "fi") return fi_salary_seniority_executive(inputs)
	if (locale === "da") return da_salary_seniority_executive(inputs)
	if (locale === "sv") return sv_salary_seniority_executive(inputs)
	return en_salary_seniority_executive(inputs)
});